/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { toast } from '@conexasaude/conexa-hero'
import { useWhiteLabelStore } from '@/store'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showErrorToast = (error: any): void => {
  const uniqueCode = useWhiteLabelStore.getState().uniqueCode
  let activationUrl = process.env.REACT_APP_ACTIVATION_PAGE_URL
  if (uniqueCode) {
    activationUrl += `/${uniqueCode}`
  }
  if (
    error?.response?.status === 422 &&
    error?.response?.data?.msg ===
      'Não foi encontrado o paciente informado ou token expirado. Tente iniciar a ativação novamente.'
  ) {
    toast({
      message: 'Conexão perdida.',
      variant: 'error',
      styles: { message: { color: 'blue' } },
      autoCloseDuration: 5000,
      action: () => {
        window.location.href = activationUrl
        sessionStorage.clear()
      },
      actionLabel: 'Reiniciar',
    })
    return
  }
  if (!error?.response) {
    toast({
      message: 'Conexão perdida.',
      variant: 'error',
      autoCloseDuration: 5000,
    })
    return
  }
  toast({
    message: error?.response?.data?.msg,
    variant: 'error',
  })
}
